<template>
  <div>
    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-show="isLoading" class="rotating">
    <div
        class="input-table"
        v-if="loaded"
    >
        <div v-if="items.length < 1"><small class="ml-2 px-2 bg-danger text-white">{{ $t('reservation.details.accommodation.no-accommodation') }}</small></div>
        <div v-if="!bedsBookingReference && bedsHotelCode && items.length > 1">
          <div class="d-flex row align-items-center">
            <div class="col-12">
              <div>Breakfast: </div>

              <input type="radio" id="breakfast-yes" value="Yes" v-model="breakfastPicked" />
              <label for="breakfast-yes">Yes</label>

              <input type="radio" id="breakfast-no" value="No" v-model="breakfastPicked" />
              <label for="breakfast-no">No</label>

              <input type="radio" id="breakfast-all" value="All" v-model="breakfastPicked" />
              <label for="breakfast-all">All</label>

              <div>Refundable: </div>

              <input type="radio" id="refundable-yes" value="Yes" v-model="refundablePicked" />
              <label for="refundable-yes">Yes</label>

              <input type="radio" id="refundable-no" value="No" v-model="refundablePicked" />
              <label for="refundable-no">No</label>

              <input type="radio" id="refundable-all" value="All" v-model="refundablePicked" />
              <label for="refundable-all">All</label>

            </div>
          </div>
          <div class="d-flex row align-items-center">
            <div class="col-6">
              <small class="ml-2 px-2">{{ $t('reservation.details.accommodation.rooms-amount-selected') }}</small>
            </div>
            <div class="col-6 border-right">
              <input style="width: 95%" class="pl-3" type="text" v-model="bedsRoomNeeded" @change="customRoomsAmountChanged($event)" />
            </div>
          </div>
        </div>
        <div v-if="items.length >= 1"
            v-for="(item, index) in items"
            :class="[disable(item) ? 'input-table-shadow-disabled' : 'input-table-shadow']"
            :key="index + reloadCount"
        >
          <div v-show="showByFilter(item)">
            <div class="d-flex row align-items-center" v-if="bedsBookingReference">
              <div class="col-4 border-right">
                <div style="display: flex">
                  <input style="width: 95%" class="pl-3" :class="{'font-italic': disable(item)}" type="text"
                         readonly="readonly" :value="item.name" v-tooltip.left-start="tooltipInfo(item)"/>
                  <img v-if="freeCancel(item)"
                       class="handle icon ui-sortable-handle" src="@/assets/svg/check.svg"
                       v-tooltip.left-start="'Free cancellation until ' + lastFreeCancelation(item)">
                </div>
              </div>
              <div class="col border-right">
                <core-money-input readonly="readonly" :amount.sync="item.purchasePrice"></core-money-input>
              </div>
              <div class="col border-right">
                <core-money-input readonly="readonly" :amount.sync="item.customPrice"></core-money-input>
              </div>
              <div class="col border-right" v-if="item.rate">
                <input class="w-100 text-center" readonly="readonly" v-model="item.rate.rooms" :placeholder="$t('reservation.details.accommodation.amount')"/>
              </div>
              <div class="col">
                <core-money-input readonly="readonly" :key="subTotal(item)" :amount="subTotal(item)"></core-money-input>
              </div>
            </div>
            <div class="d-flex row align-items-center" v-if="!bedsBookingReference">
                <div class="col-4 border-right">
                  <div style="display: flex">
                    <input style="width: 95%" class="pl-3" :class="{'font-italic': disable(item)}" type="text"
                           readonly="readonly" :value="item.name" v-tooltip.left-start="tooltipInfo(item)"/>
                    <img v-if="freeCancel(item)"
                         class="handle icon ui-sortable-handle" src="@/assets/svg/check.svg"
                         v-tooltip.left-start="'Free cancellation until ' + lastFreeCancelation(item)">
                  </div>
                </div>
                <template v-if="isFreeSale">
                    <div class="col border-right">
                      <core-money-input :key="item.key" v-if="!item.rate" readonly="readonly" :amount.sync="item.purchasePrice"></core-money-input>
                      <div v-if="item.rate">{{ formatPrice(item.purchasePrice) }}</div>
                    </div>
                    <div class="col border-right">
                        <core-money-input v-if="!item.rate" v-on:update:amount="priceChanged($event, item)" :amount.sync="item.customPrice"></core-money-input>
                        <div v-if="item.rate">{{ formatPrice(item.customPrice) }}</div>
                    </div>
                    <div class="col border-right">
                        <input class="w-100 text-center" @change="amountChanged($event, item)" v-model="item.amount" :placeholder="$t('reservation.details.accommodation.amount')"/>
                    </div>
                </template>
                <template v-else>
                    <div class="col border-right">
                        <core-money-input :disabled="disable(item)" readonly :amount="item.salePrice"></core-money-input>
                    </div>
                    <div class="col border-right">
                        <core-basic-drop-down
                            :items="availableAmount(item)"
                            :selection.sync="item.amount"
                            :disabled="disable(item)"
                            noLabel
                        ></core-basic-drop-down>
                    </div>
                </template>
                <div class="col">
                    <core-money-input :disabled="disable(item)" readonly :key="subTotal(item)" :amount="subTotal(item)"></core-money-input>
                </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'
import {moneyFormat} from '@/mixins/moneyFormat'

export default {
  mixins: [moneyFormat],
  props: {
    prices: {
      default: () => ([]),
      type: Array,
      required: true
    },
    loadedRoomTypes: {
      default: () => ([]),
      type: Array,
      required: false
    },
    passengers: {
      default: () => ([]),
      type: Array,
      required: false
    },
    service: {
      type: Object,
      required: true
    },
    statusCode: {
      type: String,
      required: true
    },
    reservationId: {
      type: String | Number,
      required: true
    },
    bedsBookingReference: {
      type: String
    },
    isFreeSale: {
      default: false,
      type: Boolean,
      required: false
    },
    departureDate: {
      default: null,
      type: String,
      required: false
    },
    arrivalDate: {
      default: null,
      type: String,
      required: false
    },
    selectedTypes: {
      type: Array,
      required: false
    },
    customRoomsAmount: {
      type: String | Number,
      required: false
    },
    bedsHotelCode: {
      type: String | Number,
      required: false
    },
    selectedClass: {
      type: String | Number,
      required: false
    },
    selectedRoomsAmount: {
      type: String | Number,
      required: false
    },
    selectedRoomType: {
      type: String,
      required: false
    },
    dataIsFilling: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      items: [],
      fromDate: this.arrivalDate,
      untilDate: this.departureDate,
      loaded: false,
      isLoading: false,
      selectedAvailability: 0,
      reloadCount: 0,
      bedsRoomNeeded: 1,
      breakfastPicked: 'Yes',
      refundablePicked: 'Yes'
    }
  },
  created () {
    this.loadTypes()
    this.bedsRoomNeeded = this.customRoomsAmount
  },
  methods: {
    calculatedPurchasePrice (item) {
      if (item.bedsRoomCode) {
        return item.purchasePrice
      }
      let koeff = 1
      if (this.service && this.service.commission) {
        koeff = 1 - (this.service.commission / 100)
      }
      item.purchasePrice = parseInt(item.customPrice ? (item.customPrice * koeff/*  * item.amount */) : item.purchasePrice)
      return item.purchasePrice
    },
    formatPrice (value) {
      let total = parseInt(value)
      return this.formatMoney(total, 'EUR')
    },
    showByFilter (item) {
      let boardsWithBreakfast = ['AB', 'B1', 'B2', 'BB', 'CB', 'DB', 'GB', 'IB', 'LB', 'QB', 'SB']
      let hasBreakfast = item.rate
        ? (boardsWithBreakfast.includes(item.rate.boardCode))
        : false
      if (
        this.statusCode === 'DONE' || this.statusCode === 'CANCELLED' || !item.rate ||
        (
          (this.refundablePicked === 'All' || (this.refundablePicked === 'Yes' && this.freeCancel(item)) || (this.refundablePicked === 'No' && !item.rate.cancellationPolicies)) &&
          (this.breakfastPicked === 'All' || (this.breakfastPicked === 'Yes' && hasBreakfast) || (this.breakfastPicked === 'No' && !hasBreakfast))
        )
      ) {
        return true
      }
      return false
    },
    customRoomsAmountChanged (event) {
      this.$emit('customRoomsAmountChanged', this.reservationId, this.bedsRoomNeeded)
      this.loadTypes(event.target.value)
    },
    freeCancel (item) {
      let firstDate = this.lastFreeCancelation(item)
      if (firstDate) {
        if (this.$moment(firstDate, 'YYYY-MM-DD HH:mm').format('YYYYMMDD') > this.$moment(new Date()).format('YYYYMMDD')) {
          return true
        }
      }
      return false
    },
    lastFreeCancelation (item) {
      let dates = []
      if (item.rate && item.rate.cancellationPolicies) {
        item.rate.cancellationPolicies.forEach((el) => {
          dates.push(this.$moment(el.from).format('YYYY-MM-DD HH:mm'))
        })
      }
      dates = dates.sort()
      return dates[0]
    },
    getBaseUniqueRate (rateKey) {
      let arRateKey = rateKey.split('|')
      let str = ''
      arRateKey.forEach((val, indx) => {
        if (indx <= 9) {
          str += (val + (indx === 9 ? '' : '|'))
        }
      })
      return str
    },
    tooltipInfo (item) {
      let text = ''
      if (item.rate) {
        text += '<b>' + item.rate.partlyFullName + '</b><br /><br />'
        if (item.rate.rateKey) {
          let arRateKey = item.rate.rateKey.split('|')
          let arPassengers = arRateKey[9].split('~')
          let rooms = parseInt(arPassengers[0])
          let adults = parseInt(arPassengers[1])
          let children = parseInt(arPassengers[2])
          text += '<b>Rooms: </b> ' + rooms + ', <b>Adults: </b> ' + adults + ', <b>Children</b>: ' + children + '<br /><br />'
        }
        if (item.rate.cancellationPolicies) {
          text += '<b>Cancellation charges</b>: <br />'
          item.rate.cancellationPolicies.forEach((elm, indx) => {
            text += 'from ' + this.$moment(elm.from).format('DD.MM.YYYY HH:mm') + ' - ' + (elm.amount * ((item.amount > 0) ? item.amount : 1)) + (indx ? '&euro;, <br />' : '&euro;<br />')
          })
        } else {
          text += 'Refundable '
        }
        text += '<br />' + item.rate.boardName
        text += '<br /><small>' + (item.rate.rateComments ? item.rate.rateComments : '') + '</small>'
      }
      return text
    },
    async loadTypes (val) {
      this.isLoading = true
      if (!val) {
        val = this.customRoomsAmount
      }
      try {
        let filters = [
          {
            property: 'serviceId',
            value: this.service.id
          },
          {
            property: 'dateFrom',
            value: this.fromDate
          },
          {
            property: 'dateUntil',
            value: this.untilDate
          }
        ]
        let passengers = []
        this.passengers.forEach((value) => {
          passengers.push(this.$moment(value.birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD'))
        })
        const previousState = Object.assign([], this.selectedTypes)
        const accoTypes = await Reservation.getAccommodationTypes(filters, passengers, this.reservationId, this.statusCode, this.selectedTypes, val)
        if (accoTypes.data.success) {
          this.isLoading = false
          let newItems = accoTypes.data.data
          // this method only checks availability, so we have to keep our rateKeys for amount > 1, if the amount will change we have another method
          newItems.forEach((newItem, indx) => {
            let rateNewLine = (newItem.rate && newItem.rate.rateKey) ? this.getBaseUniqueRate(newItem.rate.rateKey) : ''
            previousState.forEach((oldItem) => {
              let rateOldLine = oldItem.bedsRoomRate ? this.getBaseUniqueRate(oldItem.bedsRoomRate) : ''
              if (rateOldLine && rateOldLine === rateNewLine/*  && newItem.rate.rooms === oldItem.amount */ && oldItem.amount > 1) {
                newItems[indx].bedsRoomRate = newItems[indx].rate.rateKey = oldItem.bedsRoomRate
                /* newItems[indx].rate.rooms = newItems[indx].amount */
              }
            })
          })
          this.items = newItems

          if (this.dataIsFilling) {
            let selected = false
            let neededPax = Math.ceil(this.passengers.length / this.selectedRoomsAmount)
            this.items.sort((accoType1, accoType2) => accoType1.maxPax - accoType2.maxPax)
            this.items.forEach((accoType) => {
              // let isNeededType = (this.selectedRoomType === 'Single' && accoType.maxPax === 1) || (this.selectedRoomType === 'Double' && accoType.maxPax === 2) || (this.selectedRoomType === 'Triple' && accoType.maxPax === 3) || (this.selectedRoomType === 'Quadruple' && accoType.maxPax === 4)
              let isNeededType = accoType.default && accoType.minPax <= neededPax && accoType.maxPax >= neededPax
              if (!selected && isNeededType) {
                this.$set(accoType, 'amount', this.selectedRoomsAmount)
                accoType.purchasePrice = this.calculatedPurchasePrice(accoType)
                accoType.key++
                const cloneItem = Object.assign({}, accoType)
                cloneItem.amount = this.selectedRoomsAmount
                this.$emit('amountChanged', this.items, cloneItem)
                selected = true
              }
            })
            this.$emit('occupancyLoaded', true)
          }
          this.items.forEach((accoType) => {
            accoType.key = 0
            let currentPrice = null
            this.prices.forEach(price => {
              if (price.serviceId === accoType.id) {
                currentPrice = price
              }
            })
            if (accoType && accoType.salePrice) {
              this.$set(accoType, 'customPrice', parseInt(accoType.salePrice))
              if (currentPrice && currentPrice.purchasePrice) {
                this.$set(accoType, 'purchasePrice', currentPrice.purchasePrice)
                this.$set(accoType, 'salePrice', currentPrice.customPrice)
              } else {
                this.$set(accoType, 'purchasePrice', this.calculatedPurchasePrice(accoType))
              }
              // Yes the 0 has to be a string, else it will be set as undefined
              this.$set(accoType, 'amount', '0')
            }
          })
        }
      } catch (e) {
        console.log('loadTypes error', e)
      }
      this.reloadCount += 1
      this.setSelectedAmount()
      this.loaded = true
    },
    setSelectedAmount () {
      if (this.items.length && this.selectedTypes.length) {
        this.items.forEach((item) => {
          let rateKeyItemChunk = (item.rate && item.rate.rateKey) ? this.getBaseUniqueRate(item.rate.rateKey) : ''
          // Count the amount of rooms selected
          let amount = this.$_.sumBy(this.selectedTypes, (selected) => {
            let bedsRoomChunk = (selected.bedsRoomRate) ? this.getBaseUniqueRate(selected.bedsRoomRate) : ''
            if (parseInt(selected.service.id) === parseInt(item.id) && (!selected.bedsRoomRate || bedsRoomChunk === rateKeyItemChunk)) {
              return parseInt(selected.amount)
            } else {
              return 0
            }
          })
          // Get the custom price of each room type
          let selectedType = this.selectedTypes.find((selected) => {
            let bedsRoomChunk = (selected.bedsRoomRate) ? this.getBaseUniqueRate(selected.bedsRoomRate) : ''
            return (selected.service.id === item.id && (!selected.bedsRoomRate || bedsRoomChunk === rateKeyItemChunk))
          })
          if (selectedType && parseInt(selectedType.customPrice) > 0 && !item.rate) {
            this.$set(item, 'customPrice', parseInt(selectedType.customPrice))
          }
          let bedsRoomChunk = (selectedType && selectedType.bedsRoomRate) ? this.getBaseUniqueRate(selectedType.bedsRoomRate) : ''
          if (selectedType && (!item.rate || (item.rate && bedsRoomChunk === rateKeyItemChunk))) {
            this.$set(item, 'amount', amount)
          } else {
            this.$set(item, 'amount', 0)
          }
        })
      }
    },
    disable (item) {
      return this.availableAmount(item).length === 1 && !this.isFreeSale
    },
    subTotal (roomType) {
      let amount = 0
      if (this.prices) {
        let prices = this.$_.filter(this.prices, {'serviceId': roomType.id + ''})
        if (roomType.rate && roomType.rate.rateKey) {
          let rateKeyItemChunk = (roomType.rate && roomType.rate.rateKey) ? this.getBaseUniqueRate(roomType.rate.rateKey) : ''
          this.prices.forEach((item) => {
            let curKeyItemChunk = item.bedsRoomRate ? this.getBaseUniqueRate(item.bedsRoomRate) : ''
            if (item.serviceId === roomType.id && rateKeyItemChunk === curKeyItemChunk) {
              prices = [item]
            }
          })
          // prices = this.$_.filter(this.prices, {'serviceId': roomType.id + '', 'bedsRoomRate': roomType.rate.rateKey})
        }
        if (prices.length) {
          if (roomType.rate) {
            amount = parseInt(roomType.customPrice * ((roomType.amount && roomType.rate.rateKey) ? roomType.amount : roomType.rate.rooms))
          } else {
            amount = this.$_.sumBy(prices, (price) => {
              if (price.customPrice === price.salePrice * roomType.amount) {
                price.customPrice = price.salePrice
              }
              if (price.customPrice > 0) {
                return parseInt(roomType.customPrice)
              } else {
                return parseInt(price.salePrice)
              }
            })
          }
        }
      }
      return amount
    },
    availableAmount (accoType) {
      let amount = parseInt(accoType.availableRooms)
      // console.log('availableAmount', amount, accoType)
      let availableAmount = Array.from(new Array(amount), (val, index) => index + 1)
      // Prepend 0 as a value
      availableAmount.unshift(0)
      return availableAmount
    },
    amountChanged (evt, item) {
      setTimeout(() => {
        item.purchasePrice = this.calculatedPurchasePrice(item)
        item.key++
        const cloneItem = Object.assign({}, item)
        cloneItem.amount = evt.target.value
        this.$emit('amountChanged', this.items, cloneItem)
      }, 100)
    },
    priceChanged (value, item) {
      setTimeout(() => {
        item.purchasePrice = this.calculatedPurchasePrice(item)
        item.key++
        this.$emit('amountChanged', this.items, item)
      }, 100)
    }
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('amountChanged', val)
      },
      deep: true
    },
    selectedTypes: {
      handler (val) {
        // we need to change amount if it was changed (in case we don't have such amount of room in beds)
        val.forEach((selectedType) => {
          let rateKeySelectedItemChunk = (selectedType.rate && selectedType.rate.rateKey) ? this.getBaseUniqueRate(selectedType.rate.rateKey) : ''
          this.items.forEach((item, indx) => {
            let rateKeyItemChunk = (item.rate && item.rate.rateKey) ? this.getBaseUniqueRate(item.rate.rateKey) : ''
            if (rateKeyItemChunk && rateKeySelectedItemChunk === rateKeyItemChunk && item.amount !== selectedType.amount) {
              this.items[indx].amount = selectedType.amount
            }
          })
        })
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/AccommodationType.vue